// Keeps every open copy of the app (installed mobile app, phone browser tab,
// desktop tab) on the latest deploy.
//
// A deploy changes the hashed bundle name in index.html
// (/static/js/main.<hash>.js). We fetch index.html with the HTTP cache
// bypassed and compare that name with the bundle this page is running. An
// installed app on a phone is rarely closed, so without this it can keep
// showing an old version for days.

const BUNDLE_RE = /\/static\/js\/main\.[0-9a-f]+\.js/;

export function bundleIn(html) {
  const m = BUNDLE_RE.exec(html || "");
  return m ? m[0] : null;
}

export function runningBundle(doc = document) {
  for (const s of doc.querySelectorAll("script[src]")) {
    const m = BUNDLE_RE.exec(s.getAttribute("src") || "");
    if (m) return m[0];
  }
  return null;
}

export async function latestBundle(fetchImpl = fetch) {
  const res = await fetchImpl(`/index.html?v=${Date.now()}`, {
    cache: "no-store",
    headers: { "Cache-Control": "no-cache" },
  });
  if (!res.ok) return null;
  return bundleIn(await res.text());
}

// The server's bundle name when it differs from the one running, else null.
// Unknown (offline, dev server with no hashed bundle) counts as "no update".
export async function checkForUpdate(fetchImpl = fetch, doc = document) {
  const running = runningBundle(doc);
  if (!running) return null;
  try {
    const latest = await latestBundle(fetchImpl);
    return latest && latest !== running ? latest : null;
  } catch {
    return null;
  }
}

// Reload once per new build, so a stale proxy cache can never cause a loop.
const RELOADED_FOR = "erp-reloaded-for";
export function reloadForUpdate(target, win = window) {
  try {
    if (win.sessionStorage.getItem(RELOADED_FOR) === target) return false;
    win.sessionStorage.setItem(RELOADED_FOR, target);
  } catch { /* storage blocked: still reload */ }
  win.location.reload();
  return true;
}
